module.exports = __webpack_public_path__ + "img/捐献流程图.f1b57d07.png";